import { createSlice } from "@reduxjs/toolkit";
import {
  AddRejectReasonAction,
  DeleteRejectReasonAction,
  GetAllRejectReasonAction,
  UpdateRejectReasonAction,
} from "store/middlewares/dataManagement/rejectReason";

// isDeleteMeFulFilled
export const rejectReasonSlice = createSlice({
  name: "rejectReasons",
  initialState: {
    rejectReasonsLoading: true,
    rejectReasons: null,
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllRejectReasonAction.pending, (state) => {
        // state.rejectReasonsLoading = true;
        // state.rejectReasons = null;
        state.rejectReasons =
          state.rejectReasons?.result?.length > 0
            ? state.rejectReasons
            : null;
      })
      .addCase(GetAllRejectReasonAction.fulfilled, (state, action) => {
        state.rejectReasonsLoading = false;
        state.rejectReasons = action.payload.response;
      })
      .addCase(GetAllRejectReasonAction.rejected, (state) => {
        state.rejectReasonsLoading = false;
        state.rejectReasons = null;
      })

      // Delete
      .addCase(DeleteRejectReasonAction.fulfilled, (state, action) => {
        // state.rejectReasonsLoading = false;
        // state.rejectReasons = {
        //   ...state.rejectReasons,
        //   total: Number(state.rejectReasons.total) - 1,
        //   data: state.rejectReasons?.data?.filter(
        //     (item) => item.id !== action.payload.id
        //   ),
        // };
        state.rejectReasonsLoading = false;
        state.rejectReasons = action.payload.response;
      })

      //Update
      .addCase(UpdateRejectReasonAction.fulfilled, (state, action) => {
        state.rejectReasonsLoading = false;
        state.rejectReasons = {
          ...state.rejectReasons,
          result: state.rejectReasons.result.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item
          ),
        };
      })

      //Add
      .addCase(AddRejectReasonAction.fulfilled, (state, action) => {
        // state.rejectReasonsLoading = false;
        // state.rejectReasons = {
        //   ...state.rejectReasons,
        //   total: Number(state.rejectReasons.total) + 1,
        //   data: [action.payload.response, ...state.rejectReasons.data],
        // };
        state.rejectReasonsLoading = false;
        state.rejectReasons = action.payload.response;
      });
  },
});

export default rejectReasonSlice.reducer;
